/* eslint-disable */
import React, { useState, useContext, useEffect } from 'react';

//import InputFileCustom from "../../../atoms/InputFile";
import { Context } from 'context/AuthContext';
import FiltroExtrato from '../Filtro';
import ExtratoDownloads from '../Downloads';
import { GET_SELECT_LIST_REGIONAL_USUARIO } from '../../../../services/Regional';

import './styles.scss';

const Extrato = (props) => {
  const { showLoader } = useContext(Context);

  const [filtro, setFiltro] = useState({});
  const [regionais, setRegionais] = useState([]);
  var regs = [{ label: '', options: [{ label: 'BRASIL', value: 1000 }] }];
  useEffect(() => {
    (async () => {
      showLoader(true);

      let resultRegionais = await GET_SELECT_LIST_REGIONAL_USUARIO();
      if (
        resultRegionais?.value != null &&
        resultRegionais?.value != [] &&
        regs.length == 1
      ) {
        regs[0].options = regs[0].options.concat(
          resultRegionais?.value[0]?.options
        );
      }

      setRegionais(regs || []);

      showLoader(false);
    })();
  }, []);

  function onSelect(filtro) {
    setFiltro(filtro);
  }

  return (
    <div className="brf-extrato">
      <FiltroExtrato onSelect={onSelect} regionais={regionais} />
      <ExtratoDownloads regional={regionais} filtro={filtro} />
    </div>
  );
};

export default Extrato;
